import { z } from 'zod';
import {
  auditFieldsShape,
  localDateSchema,
  localDateTimeSchema,
  softDeleteShape,
  stickerRefSchema,
  utcTimestampSchema,
  uuidSchema,
} from './primitives';

/** 第一版只實作 none 與 weekly，型別預留 daily、monthly、yearly。 */
export const EVENT_RECURRENCES = ['none', 'weekly'] as const;
export const eventRecurrenceSchema = z.enum(EVENT_RECURRENCES);

export const calendarEventSchema = z.object({
  id: uuidSchema,
  title: z.string().min(1),
  note: z.string().nullable(),

  allDay: z.boolean(),
  startAtLocal: localDateTimeSchema,
  endAtLocal: localDateTimeSchema,

  completedAt: utcTimestampSchema.nullable(),
  stickers: z.array(stickerRefSchema),

  /** 可選任務關聯；獨立事件為 null。 */
  taskId: uuidSchema.nullable(),

  recurrence: eventRecurrenceSchema,
  weekdays: z.array(z.number().int().min(0).max(6)).min(1).nullable(),
  recurrenceEndDate: localDateSchema.nullable(),

  ...softDeleteShape,
  ...auditFieldsShape,
});

export const calendarReminderSchema = z.object({
  id: uuidSchema,
  eventId: uuidSchema,
  /** 事件開始前幾分鐘提醒；0 代表準時。 */
  offsetMinutes: z.number().int().nonnegative(),
  ...auditFieldsShape,
});

export type EventRecurrence = z.infer<typeof eventRecurrenceSchema>;
export type CalendarEvent = z.infer<typeof calendarEventSchema>;
export type CalendarReminder = z.infer<typeof calendarReminderSchema>;
